import React from 'react';
import {observer} from "mobx-react";
import Device from "../../../sdk/src/utils/device/device";
import classNames from "classnames";
import {CyClass} from "../../../common/cy-classes";
import {ExternalLinkIframeBox} from "./boxes/external-link-iframe.box";
import {useServices} from "../../react-hooks/use-services.hook";

interface ExternalLinkIframeComponentProps {
    id: string;
    httpVerb: 'GET' | 'POST';
    scrolling?: "auto" | 'no';
    url: string;
    onIframeCreated: (element: HTMLIFrameElement) => void;
    className?: string;
}

export const ExternalLinkIframeComponent: React.FC<ExternalLinkIframeComponentProps> = observer((props) => {
    const services = useServices();
    
    const captureIframeElementRef = (element: HTMLIFrameElement) => {
        if(props.httpVerb === 'POST') {
            services.dom.performFormPostForUrl(props.url, {
                target: props.id
            });
        }

        props.onIframeCreated(element);
    }

    return (
        <ExternalLinkIframeBox id={props.id}
                               name={props.id}
                               src={props.httpVerb === 'POST' ? '' : props.url}
                               ref={captureIframeElementRef}
                               frameBorder="0"
                               scrolling={props.scrolling ?? "auto"}
                               allow={Device.browser.getIframeAllowAttributeValue()}
                               allowFullScreen={true}
                               className={classNames(props.className, CyClass('cy-external-link-container'))}/>
    );
});